const initialState = {
  totals: 0,
  record_type: null,
  current: "",
  loading: false,
  data: [],
  options: {},
  show_data: {},
  api_call_time: 0,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "STOP_LOADING_RETAIL":
      return {
        ...state,
        loading: false,
      };
    case "LOADING_RETAIL":
      return {
        ...state,
        loading: true,
        data: [],
        show_data: {},
      };
    case "ONLY_LOADING_RETAIL":
      return {
        ...state,
        loading: true,
      };
    case "ONLY_LOADING_CUSTOM":
      return {
        ...state,
        loading: true,
      };
    case "GET_CUSTOMS":
      return {
        ...state,
        data: action.payload.data,
        totals: action.payload.totals || 0,
        current: action.payload.current || "",
        loading: false,
      };
    case "SET_RETAIL_OPTIONS":
      return {
        ...state,
        options: action.payload,
      };
    case "GET_RETAIL_PRODUCTS":
      return {
        ...state,
        api_call_time: action.payload.api_call_time || Date.now(),
        data: action.payload.data,
        totals: action.payload.totals || 0,
        current: action.payload.current || "",
        loading: false,
        show_data: action.payload.show_data || {},
      };
    case "UPDATE_RETAIL_PRODUCT":
      let getData = [...state.data];
      const updateElementId = (element) => element.id === action.payload.id;
      const findIndex = getData.findIndex(updateElementId);
      if (findIndex !== -1) {
        getData[findIndex] = action.payload;
      }
      return {
        ...state,
        data: getData,
      };
    case "REMOVE_RETAIL_PRODUCT":
      return {
        ...state,
        data: [...state.data].filter((e) => e.id !== action.payload),
        loading: false,
        totals: state.totals - 1,
      };
    default:
      return state;
  }
}
